import $ from "jquery"
import Combobox from "../../interface/combobox.class"
import ComboboxUI from "../../interface/combobox"
import Formatter from "../../model/formatter"
import serializeForm from "form-serialize"
import moment from "moment"
import Hook from "../../hook"

/** Quickscan */
class SalesQuickScanHook extends Hook {
  /**
   * Setup values
   * @param {Window} window - Window
   * @returns {void}
   */
  async afterProcess(window) {
    if (window.output.Data.Type !== "quickscanform") {
      return
    }

    // Set default settings for window
    window.bulkedit =
      window.output.Request.Criteria != null &&
      window.output.Request.Criteria.length > 0 &&
      Object.keys(window.output.Request.Criteria[0]).length >= 2 &&
      window.output.Request.Criteria[0]["CustomerID"] == null

    window.customData.isNewObject = !window.bulkedit
    window.customData.formType = "Cart"

    window.options.customKeyEvents = false
    window.output.Options.RowClickable = false
    window.renderOptions.customButtons = true

    // Add the quckscan-specific methods
    window.quickscanSubmit = quickscanSubmit
    window.quickscanDispose = quickscanDispose
    window.getRow = getRow

    // Override reload function with empty (async) function
    window.reload = async function(keepSelection = false) {}

    // Manually add buttons
    if (window.bulkedit) {
      window.customData.formType = window.output.Request.Criteria[0].Target
      window.output.Buttons = [
        {
          Event: "quickscan-dispose",
          Title: window.session.translations.Close,
        },
      ]
    } else {
      window.output.Buttons = [
        {
          Event: "quickscan-submit",
          Title: window.session.translations.Save,
        },
        {
          // TODO: action DeleteCart?
          Event: "quickscan-dispose",
          // Event: "action:CloseRentForm:Rental.virtual_QuickRent:../../Admin/WebServices/RentWebServices.asmx:CloseRentForm",
          Title: window.session.translations.Cancel,
        },
      ]
    }

    // Initialize dropdown"s for columns of type "Dropdown"
    for (let column of window.output.Table.Columns) {
      if (column.Dropdown != null && column.Dropdown.TableName != null) {
        column.Combobox = Combobox.new(null, {
          name: column.Name,
          tableName: column.Dropdown.TableName,
          columnName: column.Dropdown.ColumnName,
          openRef: column.Dropdown.OpenRef,
          nullable: true,
        })
      }
    }

    // Manually add "header"-fields and columns to the customData
    let defaultCustomData = {
      Comboboxes: {
        OrderType: Combobox.new(null, {
          name: "OrderType",
          nullable: false,
          columnName: "OrderType",
        }),
        CustomerID: Combobox.new(null, {
          name: "CustomerID",
          nullable: false,
          tableName: "Customer.Customer",
          columnName: "CustomerID",
          fetch: true,
          lazyLoading: true,
        }),
        AddressID: Combobox.new(null, {
          name: "AddressID",
          readOnly: true,
          nullable: false,
          tableName: "Customer.Address",
          columnName: "AddressID",
        }),
        TransactionTypeID: Combobox.new(null, {
          name: "TransactionTypeID",
          readOnly: true,
          nullable: false,
          tableName: "Sales.TransactionType",
          columnName: "TransactionTypeID",
        }),
        CUST_ResponsibleHearingCoach: Combobox.new(null, {
          name: "CUST_ResponsibleHearingCoach",
          readOnly: true,
          nullable: false,
          tableName: "dbo.vw_CUST_ResponsibleHearingCoach",
          columnName: "UserId",
        }),
        CategoryID: Combobox.new(null, {
          name: "CategoryID",
          nullable: true,
          tableName: "Sales.Category",
          columnName: "CategoryID",
        }),
        scannedItem: Combobox.new(null, {
          name: "scannedItem",
          freeType: true,
          tableName: "Sales.ItemPerAffiliate",
          columnName: "ItemID",
        }),
      },
      Columns: window.output.Table.Columns.filter(
        x => window.output.Data.HiddenColumns.indexOf(x.Name) < 0,
      ),
      ColumnsExtra: window.output.Table.Columns.filter(
        x => window.output.Data.HiddenColumns.indexOf(x.Name) >= 0,
      ),
    }

    for (let i in defaultCustomData) {
      window.customData[i] = defaultCustomData[i]
    }
    let orderTypes = [
      {Text: "Order", Value: "Pending"},
      {Text: "Quotation", Value: "Quotation"},
    ]
    let defaultOrderType = orderTypes[0]
    defaultCustomData.Comboboxes.OrderType.populate(orderTypes)
    defaultCustomData.Comboboxes.OrderType.setInitialValues(
      defaultOrderType.Text,
      defaultOrderType.Value,
    )
    // Enable Category and scanbox if bulkedit is false, customer is already available
    window.customData.Comboboxes.scannedItem.specification.readOnly = !window.bulkedit
    window.customData.Comboboxes.CategoryID.specification.readOnly = !window.bulkedit
  }

  /**
   * Set combobox functionality
   * @param {Window} window - Window
   * @returns {Promise} Promise
   */
  async afterRender(window) {
    if (window.output.Data.Type != "quickscanform" || window.customInit) {
      return
    }

    window.customInit = true
    window.toggleLoading(true)
    window.loading = false

    await window.render()

    window.toggleLoading(false)

    // Add existing rows
    if (
      window.output.Data.Rows != null &&
      window.output.Request.Criteria.length > 0
    ) {
      for (let i = 0; i < window.output.Data.Rows.length; i++) {
        let item = window.output.Data.Rows[i]
        item.Metadata = window.output.Data.Metadata[i]
        addRow(window.element, window.output.Data.Columns, item, window)
      }

      // Set all "option"-fields default hidden
      let $opts = $("[name*='OptionID-']", $(window.element))
      let rowID = -1
      $opts.each(function() {
        let optionname = $(this).attr("name")
        if (optionname == "OptionID-1" || optionname == "OptionID-1[]") {
          rowID += 1
        }

        if (!window.output.Data.Metadata[rowID]) {
          $(this)
            .closest(".form-field")
            .parent()
            .hide()
        } else if (
          window.output.Data.Metadata[rowID][optionname] &&
          window.output.Data.Metadata[rowID][optionname].IsVisible == false
        ) {
          $(this)
            .closest(".form-field")
            .parent()
            .hide()
        }
      })

      window.customData.TypeID =
        window.output.Request.Criteria[0][window.customData.formType + "ID"]
      window.output.Options.UploadUrl =
        window.output.Options.UploadUrl +
        "&" +
        window.customData.formType +
        "ID=" +
        window.customData.TypeID
    }

    // Set customer if window.parent is not null
    if (window.parent != null) {
      setCustomer(
        window,
        window.parent.output.FullTable.Rows[0].filter(
          x => x.Column.Name == "CustomerID",
        )[0].Value,
        "",
      )
    } else if (window.output.Request.Criteria != null &&
      window.output.Request.Criteria.length > 0 &&
      Object.keys(window.output.Request.Criteria[0]).length >= 2 &&
      window.output.Request.Criteria[0]["CustomerID"] != null)
    {
      setCustomer(
        window,
        window.output.Request.Criteria[0]["CustomerID"],
        window.output.Request.Criteria[0]["CustomerName"],
      )
    }

    calculateTotals(window)
    updateSelectCount(window)

    // Add custom events:
    $(window.element).off()

    // Delete row and redraw totals
    $(window.element).on("click", ".table-cell.delete-row", async function(e) {
      if ($(this).hasClass("disabled")) {
        return
      }

      let $row = $(this).closest(".table-row-group")
      let data = getRow($row.get(0), window, false)

      deleteRow($row.get(0), data, window, true)
      calculateTotals(window)
      updateSelectCount(window)
    })

    $(window.element).on("click", ".table-cell.action-row", async function(e) {
      if ($(this).hasClass("disabled")) {
        return
      }

      let action = this.attributes.action.value
      if (action === "duplicate") {
        let $row = $(this).closest(".table-row-group")
        let data = getRow($row.get(0), window, false)
        duplicateRow($row.get(0), data, window)
      }
      calculateTotals(window)
      updateSelectCount(window)
    })

    // Customer chosen, set Customer (setCustomer call"s createCart!)
    $(window.element).on("value-accept", "[name='CustomerID']", async function(
      e,
      arg,
    ) {
      if (!$(this).val() && !arg) {
        return
      }

      let customerID = arg || $(this).val()
      let customerName = $(this)
        .closest(".combobox")
        .find("input.combobox-input")
        .val()

      setCustomer(window, customerID, customerName)
    })

    // CategoryID changed, repopulate scanbox
    $(window.element).on("value-accept blur", "[name='CategoryID']", function(
      e,
      arg,
    ) {
      let val = arg || $(this).val()
      let specs = window.customData.Comboboxes.scannedItem.specification
      specs.override({
        filter: val === "all" || val === "" ? null : {CategoryID: val},
      })
      window.customData.Comboboxes.scannedItem.populate(window.customData.items)
    })

    // If a value in the last row is inserted, add a new (empty) row
    $(window.element).on("keyup", ".table-row-group:last-child [name]", e => {
      addNewRow(window)
    })

    // // TODO: If an itemID is filled add or update Cart? If text is empty, delete?
    // $(window.element).on("change value-change", "", async function (e) {
    //     await new Promise((resolve) => setTimeout(resolve, 100))

    //     if($(this).text() === null || $(this).text() === "") {
    //         return
    //     }
    //     // update qty  = 0
    //     // add new item

    //     addNewItem(window, $(this).text())
    // })

    //On value-change update item in database
    $("body").off("change value-change [name='DimensionID-3']")

    $("body").on("change value-change [name='DimensionID-3']", async function(
      e,
    ) {
      let $row = $(this).closest(".table-row-group")
      let data = getRow($row.get(0), window, false)

      if (data) {
        if (data.PrimaryKey) {
          let name = $(this).attr("name")
          if (name != null && name.startsWith("OptionID-")) {
            let changedOptionID = name.replace("OptionID-", "")
            if (changedOptionID.includes("[]")) {
              changedOptionID = changedOptionID.replace("[]", "")
            }
            data.Options = {[changedOptionID]: data.Options[changedOptionID]}
            if (data.Options[changedOptionID] == null)
            {
              data.Options[changedOptionID] = '-';
            }

          } else if (name != null && name.startsWith("DimensionID-")) {
            data.Options = {}
          }

          if (name) {
            try {
              await updateItem(window, data, name)
            } catch (error) {}
          }
        } else if (data.ItemID) {
          await addNewItem(window, data.ItemID)
        }
      }
    })

    $(window.element).on(
      "change value-change",
      "[name='ItemID'], [name='VariantID'], [name='Description[]'], " +
        "[name='Qty[]'], [name='PriceGross[]'], [name='Discount[]'], " +
        "[name='Comment'], [name='Composition[]'], [name='VATID[]'], " +
        "[name='CUST_Reference[]'], [name='CUST_ExtraLabel[]'], [name='CUST_Reference'], [name='CUST_ExtraLabel'], " +
        "[name*='DimensionID-'], [name='DimensionID-'], [name*='OptionID-'], [data-field-index]",
      async function(e) {
        let $row = $(this).closest(".table-row-group")
        let data = getRow($row.get(0), window, false)

        if (data) {
          await new Promise(resolve => setTimeout(resolve, 100))
          if (window.lock === "listener-lock-2") {
            window.lock = ""
            return
          }

          window.lock = "listener-lock-1"

          if (data.PrimaryKey) {
            let name = $(this).attr("name")
            if (name != null && name.startsWith("OptionID-")) {
              let changedOptionID = name.replace("OptionID-", "")
              if (changedOptionID.includes("[]")) {
                changedOptionID = changedOptionID.replace("[]", "")
              }
              data.Options = {[changedOptionID]: data.Options[changedOptionID]}
              if (data.Options[changedOptionID] == null)
              {
                data.Options[changedOptionID] = '-';
              }

            } else if (name != null && name.startsWith("DimensionID-")) {
              data.Options = {}
            }

            if (name) {
              await updateItem(window, data, name)
            }
          } else if (data.ItemID) {
            await addNewItem(window, data.ItemID)
          }
        }
      },
    )

    // New item scanned, prevent default and addnewRow
    $(window.element).on(
      "keyup value-accept",
      "[name=scannedItem]",
      async function(e, arg) {
        if (
          (e.type == "keyup" && e.which != 13) ||
          (e.type == "value-accept" && $(this).attr("name") != "scannedItem")
        ) {
          return
        }

        e.preventDefault()

        let isScanbox = $(this).attr("name") === "scannedItem"
        let form = getHeader(window)
        let scannedValue =
          arg || (isScanbox ? form.scannedItem : $(this).text())

        if (scannedValue === null || scannedValue === "") {
          return
        }

        if (isScanbox) {
          $(window.element)
            .find("[name=scannedItem]")
            .closest(".combobox")
            .find("input")
            .val("")
          delete form.scannedItem
        } else {
          $(this).text("")
        }

        $(window.element)
          .find(".scroll-container")
          .scrollTop(
            $(window.element)
              .find(".scroll-container")
              .get(0).scrollHeight,
          )
        let $indicatorRow

        if (isScanbox) {
          let $lastrow = $(window.element).find(".table-row-group:last-child")
          $indicatorRow = addNewRow(window)
          $lastrow.remove()
        } else {
          $indicatorRow = $(this).closest(".table-row-group")
        }
        // if(isScanbox || $(this).is(".new-row *")) {
        //     addNewRow(window)
        // }

        $indicatorRow
          .find("[data-field-index]:first")
          .text("Loading: " + scannedValue)

        addNewItem(window, scannedValue)
        $(window.element)
          .find("[name=scannedItem]")
          .focus()
      },
    )
  }
}

// Return Header-values
function getHeader(window) {
  let form = serializeForm(
    $(window.element)
      .find("form.form-view")
      .get(0),
    {
      hash: true,
      empty: true,
      disabled: true,
    },
  )

  if (form.CustomerID == null && window.parent != null) {
    form.CustomerID = window.parent.output.FullTable.Rows[0].filter(
      x => x.Column.Name == "CustomerID",
    )[0].Value
  }

  return form
}

// Return Table.Columns
function getTypes(window) {
  let columnInfo = {}

  for (let info of window.output.Table.Columns) {
    columnInfo[info.Name] = info
  }
  return columnInfo
}

// Return value"s for all selected rows
// TODO: What is selected? On unselect, delete?
function getRows(window) {
  let rows = []

  $(window.element)
    .find(".table-body .table-row-group")
    .each(function() {
      if (
        $(this).is(".table-row-group:last-child") ||
        !$(this)
          .find(".table-row")
          .is(".added-row")
      ) {
        return
      }
      rows = rows.concat(getRow(this, window, true) || [])
    })
  return rows
}

// Retrieve one row based on the first element
function getRow(el, window, selectAllFields) {
  let data = {}
  let dirty = false
  let options = {}
  let dimensions = {}
  let columnInfo = getTypes(window)

  $(el)
    .find("[name]")
    .each(function() {
      let name = $(this)
        .attr("name")
        .split(/\[|\]/g)
        .shift()

      if (!name) {
        return
      }

      let value = !$(this).is("input")
        ? $(this).text()
        : !$(this).is(":checkbox")
        ? $(this).val()
        : $(this).is(":checked")

      if (typeof $(this).data("override-value") != "undefined") {
        value = $(this).data("override-value")
      }

      if (value) {
        dirty = true
      }

      if (!value.indexOf || value.indexOf("OBJECTDEF:") != 0) {
        let info = columnInfo[name] || {}

        if (
          info.Type === "Decimal" ||
          info.Type === "Money" ||
          info.Type === "Money"
        ) {
          value = value != "" ? Number(value) : null
        } else if (info.Type === "DateTime" || info.Type === "Date") {
          value = value
            ? moment(value, "DD-MM-YYYY HH:mm").format("YYYY-MM-DD HH:mm:ss")
            : null
        } else {
          value = value || (value === false || value === "false" ? false : null)
          value = typeof value === "string" ? value.trim() : value
        }
      } else {
        value = JSON.parse(value.slice("OBJECTDEF:".length))
      }

      // If optionID is required and not filled, set to null
      if (
        selectAllFields &&
        name.indexOf("OptionID-") != -1 &&
        value == null &&
        $(this)
          .closest(".form-field")
          .parent()
          .hasClass("required-field")
      ) {
        options[Number(name.replace("OptionID-", ""))] = null
      } else if (name.indexOf("OptionID-") != -1 && value != null) {
        options[Number(name.replace("OptionID-", ""))] = Number(value)
      } else if (name.indexOf("DimensionID-") != -1 && value != null) {
        dimensions[Number(name.replace("DimensionID-", ""))] = Number(value)
        data[name] = Number(value)
      } else {
        data[name] = value
      }
    })

  data.Options = options
  data.Dimensions = dimensions

  return dirty && data
}

// Update input-value"s in a row
function fillInputs(el, row, columnInfo, window, initialData) {
  let fullReadOnly =
    Object.keys(columnInfo || {}).filter(x => !columnInfo[x].IsReadOnly)
      .length == 0
  $(el)
    .find(".delete-row")
    .toggleClass("disabled", fullReadOnly)

  let supportedNames = []

  $(el)
    .find("[name]")
    .each(function() {
      let name = $(this)
        .attr("name")
        .replace(/\[\]$/, "")

      if (!name) {
        return
      }

      let column = columnInfo[name] || {}
      let value =
        (row[name] != null && typeof row[name] == "object"
          ? "OBJECTDEF:" + JSON.stringify(row[name])
          : Formatter.parseValue(column, row[name])) || String()

      supportedNames.push(name)

      if (column.IsVisible == false) {
        $(this)
          .closest(".form-field")
          .parent()
          .hide()
        $(this)
          .closest(".form-field")
          .parent()
          .removeClass("required-field")
      } else {
        $(this)
          .closest(".form-field")
          .parent()
          .show()
        $(this)
          .closest(".form-field")
          .parent()
          .addClass("required-field")
      }

      if (
        $(this)
          .parent()
          .is(".combobox")
      ) {
        let parent = $(this).parent()
        parent.find(".combobox-input").val(column.Description || "")
        parent.toggleClass("disabled", column.IsReadOnly)
        parent.find(".combobox-input").prop("disabled", column.IsReadOnly)

        let cb = ComboboxUI.getClass(parent)
        cb.setInitialValues(column.Description || "", value)
      }

      if (column.Dropdown != null && column.Dropdown.Items != null) {
        $(this).data("override-value", value)
        let description = (
          column.Dropdown.Items.filter(x => x.Value == value)[0] || {}
        ).Text
        $(this).text(description)
      } else if ($(this).is("input")) {
        if (this.type === "checkbox") {
          $(this).prop("checked", value)
        } else {
          $(this).val(value)
        }
        $(this).prop(
          "disabled",
          Boolean(column.IsReadOnly) || column.IsVisible == false,
        )
      } else {
        $(this).text(value)
        $(this).prop("contenteditable", !column.IsReadOnly)
      }

      $(this).data("server-value", value)

      if (initialData) {
        $(this).data("initial-data", true)
      }
    })

  for (let name in row) {
    if (supportedNames.indexOf(name) === -1) {
      let value =
        (row[name] != null && typeof row[name] == "object"
          ? "OBJECTDEF:" + JSON.stringify(row[name])
          : Formatter.parseValue(columnInfo[name] || {}, row[name])) || String()
      $(el).append(
        $("<input>")
          .prop("type", "hidden")
          .prop("name", name)
          .val(value),
      )
    }
  }
}

// Add an row with data
function addRow(container, columnInfo, item, window) {
  if (
    item.Qty &&
    String(item.Qty).indexOf(",") != -1 &&
    String(item.Qty).indexOf(".") === -1
  ) {
    item.Qty = item.Qty.replace(/,/g, ".")
  }

  let $lastRow = $(container).find(".table-row-group:last-child")
  let $newRow = $lastRow.clone()
  $newRow.attr("data-row-index", +$lastRow.attr("data-row-index") + 1)

  fillInputs(
    $newRow.get(0),
    item,
    Formatter.applyMetadataRow(columnInfo, item.Metadata),
    window,
    true,
  )

  $newRow.find(".dropdown.combobox").each(function() {
    // Create new combobox object for every new row, every dropdown
    let previousCb = ComboboxUI.getClass($(this))

    let newCb = Combobox.new(null, {
      name: previousCb.specification.name,
      tableName: previousCb.specification.tableName,
      columnName: previousCb.specification.columnName,
      openRef: previousCb.specification.openRef,
      nullable: previousCb.specification.nullable,
    })

    newCb.startingValue = $(this)
      .find("input.combobox-input")
      .val()

    $(this).attr("data-id", newCb.id)
  })

  $newRow
    .find(".table-row")
    .removeClass("new-row")
    .addClass("added-row")
  $newRow.insertBefore($lastRow)
  $lastRow.find("[data-field-index]:first").text("")
}

// Add an empty row
function addNewRow(window) {
  let $old = $(window.element).find(".table-row-group:last-child")

  if ($old.length < 0) {
    return
  }

  let $trClone = $old.clone()
  $trClone.attr("data-row-index", +$old.attr("data-row-index") + 1)
  $trClone.find("[contenteditable]").html("")
  $trClone.find("select").val("")
  $trClone.removeClass("dirty")
  $trClone.find("input").val(String())

  $trClone.find(".dropdown.combobox").each(function() {
    // Create new combobox object for every new row, every dropdown
    let previousCb = ComboboxUI.getClass($(this))

    let newCb = Combobox.new(null, {
      name: previousCb.specification.name,
      tableName: previousCb.specification.tableName,
      columnName: previousCb.specification.columnName,
      openRef: previousCb.specification.openRef,
      nullable: previousCb.specification.nullable,
    })

    $(this).attr("data-id", newCb.id)
  })

  $trClone.insertAfter($old)
  return $trClone
}

// Delete a row from the gui, optionally remove from server
async function deleteRow(el, row, window, removeFromServer) {
  if (!$(el).is(":last-child")) {
    let result = {}

    if (removeFromServer) {
      let data = {PrimaryKey: row.PrimaryKey, Qty: 0}
      result = await updateItem(window, data, '') // row.PrimaryKey, 0
    }

    if (!removeFromServer || (result != null && result.IsSucces)) {
      $(el).remove()
      await refreshPrices(window)
    } else if (result != null && result.ErrorMessage != null) {
      window.message("warning", result.ErrorMessage)
    }
  }
}

async function duplicateRow(el, row, window) {
  let commandName =
    window.customData.formType +
    ".Duplicate" +
    window.customData.formType +
    "Item"
  let commandArgument = {}
  commandArgument[window.customData.formType + "ItemID"] = Number(
    row.PrimaryKey,
  )
  let result = await handleCommand(window, commandName, commandArgument)
  await applyCommandResult(window, result)
  await refreshPrices(window)
  return result
}

// Sum totals
function sumTotal(window, name) {
  let total = 0

  $(window.element)
    .find("[name='" + name + "[]'], [name='" + name + "']")
    .each(function() {
      total += Number($(this).is("input") ? $(this).val() : $(this).text()) || 0
    })

  return total
}

// Calculate totals
function calculateTotals(window) {
  let totalExcVAT = sumTotal(window, "TotalExcVAT")
  let totalIncVAT = sumTotal(window, "TotalIncVAT")
  $("[data-total-price]").text(totalExcVAT.toFixed(2))
  $("[data-total-btw]").text(Math.max(0, totalIncVAT - totalExcVAT).toFixed(2))
  $("[data-total-btw-price]").text(totalIncVAT.toFixed(2))
}

// Update select-count
function updateSelectCount(window) {
  let rows = getRows(window)

  $("[data-select-count]").text(rows.length)
}

// Set customer, create Cart, enable other fields
async function setCustomer(window, customerID, customerName) {
  window.customData.Comboboxes.AddressID.specification.readOnly = false
  window.customData.Comboboxes.TransactionTypeID.specification.readOnly = false
  window.customData.Comboboxes.CUST_ResponsibleHearingCoach.specification.readOnly = false
  window.customData.Comboboxes.CategoryID.specification.readOnly = false
  window.customData.Comboboxes.scannedItem.specification.readOnly = false

  window.customData.CustomerID = customerID
  window.customData.CustomerIDName = customerName

  window.customData.Comboboxes.CustomerID.specification.readOnly = true
  window.customData.Comboboxes.CustomerID.setInitialValues(
    window.customData.CustomerIDName,
    window.customData.CustomerID,
  )

  window.customData.Comboboxes.AddressID.specification.override({
    filter: {CustomerID: window.customData.CustomerID},
  })
  window.customData.Comboboxes.CUST_ResponsibleHearingCoach.specification.override(
    {
      filter: {CustomerID: window.customData.CustomerID},
    },
  )

  window.bulkedit = true

  if (window.customData.isNewObject) {
    window.customData.TypeID = 0

    await window.render()

    $("[name=Reference]").prop("disabled", false)

    // Set all "option"-fields default hidden
    let $opts = $("[name*='OptionID-']", $(window.element))
    $opts.each(function() {
      if ($(this).closest(".form-field").length == 0) {
        $(this).prop("disabled", true)
      } else {
        $(this)
          .closest(".form-field")
          .parent()
          .hide()
      }
    })

    let result = await handleCommand(window, "Cart.CreateCart", {
      CustomerID: customerID,
    })
    await window.toggleLoading(false)
    
    if (result != null && result.IsSucces) {
      window.customData.TypeID = result.CartID
      window.output.Options.UploadUrl =
        window.output.Options.UploadUrl + "&CartID=" + result.CartID
    }

    // Select first (default address)
    let $el = $("input[type=hidden][name='AddressID']", $(window.element))
    let cbAddress = ComboboxUI.getClass($el.closest(".combobox"))
    await ComboboxUI.fetch(cbAddress, "")
    ComboboxUI.selectByIndex(cbAddress, 0)
    ComboboxUI.close(cbAddress)

    // Select first (default CUST_ResponsibleHearingCoach)
    $el = $(
      "input[type=hidden][name='CUST_ResponsibleHearingCoach']",
      $(window.element),
    )
    let cbResponsibleHearingCoach = ComboboxUI.getClass(
      $el.closest(".combobox"),
    )
    await ComboboxUI.fetch(cbResponsibleHearingCoach, "")
    ComboboxUI.selectByIndex(cbResponsibleHearingCoach, 0)
    ComboboxUI.close(cbResponsibleHearingCoach)

    // Add custom events:
    $(window.element).off()

    // Delete row and redraw totals
    $(window.element).on("click", ".table-cell.delete-row", async function(e) {
      if ($(this).hasClass("disabled")) {
        return
      }

      let $row = $(this).closest(".table-row-group")
      let data = getRow($row.get(0), window, false)

      deleteRow($row.get(0), data, window, true)
      calculateTotals(window)
      updateSelectCount(window)
    })

    $(window.element).on("click", ".table-cell.action-row", async function(e) {
      if ($(this).hasClass("disabled")) {
        return
      }

      let action = this.attributes.action.value
      if (action === "duplicate") {
        let $row = $(this).closest(".table-row-group")
        let data = getRow($row.get(0), window, false)
        duplicateRow($row.get(0), data, window)
      }
      calculateTotals(window)
      updateSelectCount(window)
    })

    // Customer chosen, set Customer (setCustomer call"s createCart!)
    $(window.element).on("value-accept", "[name='CustomerID']", async function(
      e,
      arg,
    ) {
      if (!$(this).val() && !arg) {
        return
      }

      let customerID = arg || $(this).val()
      let customerName = $(this)
        .closest(".combobox")
        .find("input.combobox-input")
        .val()

      setCustomer(window, customerID, customerName)
    })

    // CategoryID changed, repopulate scanbox
    $(window.element).on("value-accept blur", "[name='CategoryID']", function(
      e,
      arg,
    ) {
      let val = arg || $(this).val()
      let specs = window.customData.Comboboxes.scannedItem.specification
      specs.override({
        filter: val === "all" || val === "" ? null : {CategoryID: val},
      })
      window.customData.Comboboxes.scannedItem.populate(window.customData.items)
    })

    // If a value in the last row is inserted, add a new (empty) row
    $(window.element).on("keyup", ".table-row-group:last-child [name]", e => {
      addNewRow(window)
    })

    // // TODO: If an itemID is filled add or update Cart? If text is empty, delete?
    // $(window.element).on("change value-change", "", async function (e) {
    //     await new Promise((resolve) => setTimeout(resolve, 100))

    //     if($(this).text() === null || $(this).text() === "") {
    //         return
    //     }
    //     // update qty  = 0
    //     // add new item

    //     addNewItem(window, $(this).text())
    // })

    // On value-change update item in database
    $(window.element).on(
      "change value-change",
      "[name='ItemID'], [name='VariantID'], [name='Description[]'], " +
        "[name='Qty[]'], [name='PriceGross[]'], [name='Discount[]'], " +
        "[name='CUST_Reference[]'], [name='CUST_ExtraLabel[]'], [name='CUST_Reference'], [name='CUST_ExtraLabel'], " +
        "[name='Comment'], [name='Composition[]'], [name='VATID[]'], [name*='DimensionID-'], [name='DimensionID-'], [name*='OptionID-'], [name='OptionID-']" +
        "[data-field-index]",
      async function(e) {
        let $row = $(this).closest(".table-row-group")
        let data = getRow($row.get(0), window, false)

        if (data) {
          if (window.lock === "listener-lock-1") {
            window.lock = ""
            return
          }

          window.lock = "listener-lock-2"
          // window.toggleLoading(true)
          await new Promise(resolve => setTimeout(resolve, 100))

          if (data.PrimaryKey) {
            let name = $(this).attr("name")
            if (name != null && name.startsWith("OptionID-")) {
              let changedOptionID = name.replace("OptionID-", "")
              if (changedOptionID.includes("[]")) {
                changedOptionID = changedOptionID.replace("[]", "")
              }
              data.Options = {[changedOptionID]: data.Options[changedOptionID]}
              if (data.Options[changedOptionID] == null)
              {
                data.Options[changedOptionID] = '-';
              }

            } else if (name != null && name.startsWith("DimensionID-")) {
              data.Options = {}
            }

            if (name) {
              var itemID = data.ItemID
              var discount = Number(data.Discount)
              var pricegross = Number(data.PriceGross)
              
              await updateItem(window, data, name)
              if (name == "VariantID") {
                // recalculate/refresh other variant's from the same item
                var variantIDs = []
                $(window.element).find("[name='ItemID']").each(function() {
                  if ($(this).data('serverValue') == itemID)
                  {
                    var primaryKey = $("[name='PrimaryKey[]']", $(this).closest(".table-row-group")).val()
                    var variantID = $("[name='VariantID']", $(this).closest(".table-row-group")).val()
                    if (data.PrimaryKey != primaryKey && variantIDs.indexOf(variantID) == -1) {
                      variantIDs.push(variantID)
                    }
                  }
                })

                for (let index = 0; index < variantIDs.length; ++index) {
                  window.customData.ItemID = itemID
                  window.customData.VariantID	= variantIDs[index]
                  window.customData.ItemDiscount = discount
                  window.customData.ItemPrice	= pricegross
                  window.customData.ItemPriceCalcReason	= 'No price reason set.'
                  await refreshPrices(window)
                }
              }
            }
          } else if (data.ItemID) {
            await addNewItem(window, data.ItemID)
          }
        }
        // window.toggleLoading(false)
      },
    )

    // New item scanned, prevent default and addnewRow
    $(window.element).on(
      "keyup value-accept",
      "[name=scannedItem]",
      async function(e, arg) {
        if (
          (e.type == "keyup" && e.which != 13) ||
          (e.type == "value-accept" && $(this).attr("name") != "scannedItem")
        ) {
          return
        }

        e.preventDefault()

        let isScanbox = $(this).attr("name") === "scannedItem"
        let form = getHeader(window)
        let scannedValue =
          arg || (isScanbox ? form.scannedItem : $(this).text())

        if (scannedValue === null || scannedValue === "") {
          return
        }

        if (isScanbox) {
          $(window.element)
            .find("[name=scannedItem]")
            .closest(".combobox")
            .find("input")
            .val("")
          delete form.scannedItem
        } else {
          $(this).text("")
        }

        $(window.element)
          .find(".scroll-container")
          .scrollTop(
            $(window.element)
              .find(".scroll-container")
              .get(0).scrollHeight,
          )
        let $indicatorRow

        if (isScanbox) {
          let $lastrow = $(window.element).find(".table-row-group:last-child")
          $indicatorRow = addNewRow(window)
          $lastrow.remove()
        } else {
          $indicatorRow = $(this).closest(".table-row-group")
        }
        // if(isScanbox || $(this).is(".new-row *")) {
        //     addNewRow(window)
        // }

        $indicatorRow
          .find("[data-field-index]:first")
          .text("Loading: " + scannedValue)

        addNewItem(window, scannedValue)
        $(window.element)
          .find("[name=scannedItem]")
          .focus()
      },
    )
  }
}

// Add a new item to the cart or order
async function addNewItem(
  window,
  itemID,
  qty,
  variantID,
  priceGross,
  discount,
  dimensionObjects,
  options,
) {
  let commandName =
    window.customData.formType + ".AddItemTo" + window.customData.formType

  let commandArgument = {
    ItemID: itemID,
    VariantID: variantID,
    Qty: qty,
    PriceGross: priceGross,
    Discount: discount,
    DiSelectedDimensionObjectIDs: dimensionObjects,
    DiSelectedOptionIDs: options,
  }

  let result = await handleCommand(window, commandName, commandArgument)
  await applyCommandResult(window, result)
  await refreshPrices(window)
}

// Update an existing item in the cart or order
async function updateItem(window, data, changedFieldName) {
  if (data.PriceGross != null) {
    data.PriceGross = Number(data.PriceGross)
  }
  if (data.Discount != null) {
    data.Discount = Number(data.Discount)
  }

  let commandName =
    window.customData.formType + ".UpdateItemTo" + window.customData.formType
  let commandArgument = {
    ItemID: data.ItemID,
    ItemDescription: data.ItemDescription,
    VariantID: data.VariantID,
    VariantDescription: data.VariantDescription,
    Qty: Number(data.Qty),
    PriceGross: data.PriceGross,
    BasicUnitPriceNett: data.BasicUnitPriceNett,
    Discount: data.Discount,
    Comment: data.Comment,
    Composition: data.Composition,
    CUST_Reference: data.CUST_Reference,
    CUST_ExtraLabel: data.CUST_ExtraLabel,
    VATID: data.VATID,
    SelectedDimensionObjectIDs: data.Dimensions,
    SelectedOptionIDs: data.Options,
  }

  commandArgument[window.customData.formType + "ItemID"] = Number(
    data.PrimaryKey,
  )

  let result = await handleCommand(window, commandName, commandArgument)
  await applyCommandResult(window, result)

  if (
    (commandName == 'Cart.UpdateItemToCart' && changedFieldName == 'Qty[]') ||
    (commandName == 'Order.UpdateItemToOrder' && changedFieldName == 'Qty[]')
   ) {
    window.customData.ItemDiscount = data.Discount
    window.customData.ItemPrice = data.PriceGross
    window.customData.ItemPriceCalcReason	= 'No price reason set.'
    await refreshPrices(window)
  }

  return result
}

// HandleCommand: uses session.request to handle the command
async function handleCommand(window, commandName, commandArgument) {
  commandArgument[window.customData.formType + "ID"] = window.customData.TypeID

  // Disable for now
  await window.toggleLoading(true)
  try {
    let result = await window.session.request(
      "/Admin/WebServices/CommandWebService.asmx/HandleCommand",
      {
        commandName: commandName,
        commandArgument: commandArgument,
      },
    )
    
    let itemID = null
    let variantID = null
    if (commandArgument.ItemID) {
      itemID = commandArgument.ItemID
      variantID = commandArgument.VariantID
    }
    if (!itemID && commandArgument[window.customData.formType + "ItemID"])
    {
      let pkCells = $("[name='PrimaryKey[]']"),
      currentPK = pkCells.filter(function(){return $(this).text() ==commandArgument[window.customData.formType + "ItemID"]}),
      row = currentPK.closest(".table-row-group"),
      rowData = window.getRow(row.get(0), window, false)

      itemID = rowData.ItemID
      variantID = rowData.VariantID
    }

    window.customData.ItemID = itemID
    window.customData.VariantID = variantID
    let priceDiscount = await priceForItem(window, itemID, variantID)	

    window.customData.ItemDiscount = priceDiscount.discount	
    window.customData.ItemPrice = priceDiscount.price
    window.customData.ItemPriceCalcReason = priceDiscount.pricecalcreason
    window.customData.ItemPriceCalcReasonSalesPriceID = priceDiscount.pricecalcreasonsalespriceid

    // Disable for now
    await window.toggleLoading(false)
    return result
  } catch (err) {
    // Disable for now
    await window.toggleLoading(false)
    window.message("warning", err.message)
    throw err
  }
}

// Apply results of handled command to the GUI
async function applyCommandResult(window, result) {
  if (result.IsSucces) {
    for (let i in result.Items) {
      let item = result.Items[i]
      if (item.Status == "Created") {
        // Add Row to GUI
        addRow(window.element, window.output.Data.Columns, item, window)

        // Remove empty row if it's not the last row
        let $emptyCell = $(window.element)
          .find("[name='PrimaryKey[]']")
          .filter(function() {
            return $(this).text() === ""
          })
        let $emptyRow = $($emptyCell[0]).parents(".table-row-group")
        let $lastrow = $(window.element).find(".table-row-group:last-child")
        if (
          $emptyRow.length > 0 &&
          $lastrow.length > 0 &&
          $emptyRow[0] !== $lastrow[0]
        ) {
          $emptyRow.remove()
        }
      } else {
        let $row = $(window.element)
          .find(".table-row-group")
          .filter(function() {
            return (
              $(this)
                .find("[name='PrimaryKey[]']")
                .text() == item.OldPrimaryKey
            )
          })

        if (item.Status === "Updated") {
          fillInputs(
            $row.get(0),
            item,
            Formatter.applyMetadataRow(
              window.output.Data.Columns,
              item.Metadata,
            ),
            window,
          )
          let $lastrow = $(window.element).find(".table-row-group:last-child")
          $lastrow.find("[data-field-index]:first").text("")
        } else if (item.Status == "Deleted") {
          await deleteRow($row.get(0), item, window, false)
        }
      }
    }

    calculateTotals(window)
    updateSelectCount(window)
  }
  if (result != null && result.ErrorMessage != null) {
    window.message("warning", result.ErrorMessage)
  }
}

async function priceForItem(window, itemID, variantID) {
  let qty = 0

  $("[name='Qty[]']" ,
    $(window.element).find("[name='ItemID']").filter(function(){return $(this).data('serverValue') ==itemID}).closest(".table-row-group")
  ).each(function() {
    if (variantID == null || $("[name='VariantID']", $(this).closest(".table-row-group")).val() == variantID)
    {
      qty += +$(this).text()||0;
    }
  });

  if (qty <= 0 || !itemID) {
    return 0
  }

  if (variantID)
  {
    return await window.session.request(
      "/Admin/WebServices/CommandWebService.asmx/GetSalesPriceForItemAndVariant",
      {
        customerID: window.customData.CustomerID,
        itemID: itemID,
        variantID: variantID,
        qty: qty -1  // server is adding +1
      },
    )  
  }
else {
    return await window.session.request(
      "/Admin/WebServices/CommandWebService.asmx/GetSalesPriceForItem",
      {
        customerID: window.customData.CustomerID,
        itemID: itemID,
        qty: qty -1  // server is adding +1
      },
    )
  }
}

async function refreshPrices(window) {	
  if (window.customData.ItemID) {	
    let itemID = window.customData.ItemID	
    let variantID = window.customData.VariantID	
    let oldDiscount = window.customData.ItemDiscount	
    let oldPrice = window.customData.ItemPrice	
    let priceDiscount = await priceForItem(window, itemID, variantID)	
    let newDiscount = priceDiscount.discount	
    let newPrice = priceDiscount.price	
    let newpricecalcreason = priceDiscount.pricecalcreason
    let newpricecalcreasonsalespriceid = priceDiscount.pricecalcreasonsalespriceid
    	
    window.customData.ItemID = null	
    window.customData.VariantID = null
    window.customData.ItemDiscount = null	
    window.customData.ItemPrice = null	
    window.customData.ItemPriceCalcReason	= 'No price reason set.'
    window.customData.ItemPriceCalcReasonSalesPriceID = null
    
    if ((newDiscount && (newDiscount != oldDiscount || !oldDiscount))	
    || (newPrice && oldPrice && newPrice != oldPrice)) {	
      oldPrice = Number(oldPrice).toFixed(2)	
      newPrice = Number(newPrice).toFixed(2)	
      $("[name='Discount[]']" ,$("[name='ItemID']").filter(function(){return $(this).data('serverValue') ==itemID}).closest(".table-row-group")).each(function() {	
        if (variantID == null || $("[name='VariantID']", $(this).closest(".table-row-group")).val() == variantID)
        {
          if ($(this).text() != newDiscount && ($(this).text() == oldDiscount || !oldDiscount)) {	
            $(this).text(newDiscount)	
            $(this).change()	
          }	
        }
      })	
      	
      $("[name='PriceGross[]']" ,$("[name='ItemID']").filter(function(){return $(this).data('serverValue') ==itemID}).closest(".table-row-group")).each(function() {	
        if (variantID == null || $("[name='VariantID']", $(this).closest(".table-row-group")).val() == variantID)
        {
          if ($(this).text() != newPrice && $(this).text() == oldPrice) {	
              $(this).text(newPrice)
              $(this).change()	
          }	
        }
      })	
    }
    
    $("[name='PriceGross[]']" ,$("[name='ItemID']").filter(function(){return $(this).data('serverValue') ==itemID}).closest(".table-row-group")).each(function() {	
      if (variantID == null || $("[name='VariantID']", $(this).closest(".table-row-group")).val() == variantID)
      {
        if ($(this).text() == newPrice) {	
            $("[name='TotalExcVAT[]']", $(this).closest(".table-row-group")).prop('title', newpricecalcreason)
            if (newpricecalcreasonsalespriceid != null)
            {
              $('.opensalesprice', $(this).closest(".table-row-group")).attr('data-window-event', 'open:Sales.SalesPrice:SalesPriceID:' + newpricecalcreasonsalespriceid + ':')
              $('.opensalesprice', $(this).closest(".table-row-group")).show();
            } else {
              $('.opensalesprice', $(this).closest(".table-row-group")).hide();
            }
        }	
      }
    })	
  }	
}

// Submit-button, create an order.
async function quickscanSubmit() {
  let rowID = -1
  let rows = getRows(this)

  // sleep 200 miliseconds, on-change event contains a time-out of 100 miliseconds
  // Without this sleep some change-events are triggered but not (yet) completely executed
  await new Promise(resolve => setTimeout(resolve, 200))

  for (let row of rows) {
    let options = row.Options
    rowID += 1

    // if Option 1 is true (1), make sure al required options are set
    if (row.Options[1] == 1) {
      for (let column of this.output.Table.Columns) {
        if (column.Name.startsWith("DimensionID-")) {
          var value = row[column.Name]
          if (!value) {
            let requiredFieldMessage =
              window.session.translations.ExceptionRequiredFieldNotGiven
            this.message(
              "error",
              requiredFieldMessage.replace("{}", column.Title),
            )
            return
          }
        }
      }
    }
  }

  await this.toggleLoading(true)
  let header = getHeader(this)
  let result = await handleCommand(this, "Cart.CreateOrder", {
    AddressID: header.AddressID,
    Reference: header.Reference,
    CUST_ResponsibleHearingCoach: header.CUST_ResponsibleHearingCoach,
    OrderType: header.OrderType,
    TransactionTypeID: header.TransactionTypeID,
  })
  await this.toggleLoading(false)

  if (result.IsSucces) {
    await this.handleActionResponse(result.ActionResponse)
    this.dispose(false)
  } else {
    this.message("warning", result.ErrorMessage)
  }
}

// Dispose/Close-button, refresh the tab "items"
async function quickscanDispose() {
  // sleep 200 miliseconds, on-change event contains a time-out of 100 miliseconds
  // Without this sleep some change-events are triggered but not (yet) completely executed
  await new Promise(resolve => setTimeout(resolve, 200))

  if (this.parent) {
    await this.parent.reload()

    // Re-fetch item tab (first tab) if pagesize or pageindex where modified
    if ((this.parent.pageIndexPerTab && this.parent.pageIndexPerTab[0]) ||
        (this.parent.pageSizePerTab && this.parent.pageSizePerTab[0])) {

          if (this.parent.pageIndexPerTab && this.parent.pageIndexPerTab[0]) {
            this.parent.sub.window.input.Data.PageNumber = this.parent.pageIndexPerTab[0]
          }

          if (this.parent.pageIndexPerTab && this.parent.pageSizePerTab[0]) {
            this.parent.sub.window.input.Data.PageSize = this.parent.pageSizePerTab[0]
          }

          await this.parent.sub.window.fetch()
    }
  } else {
    await handleCommand(this, "Cart.Cancel", {})
    this.dispose(false)
  }
}

/** @ignore */
export default new SalesQuickScanHook()
